import {Action} from "@ngrx/store";
import {type} from "@cosbeni/core";
import {CATEGORY} from "../common";

export interface IDatabaseActions {
  LOAD_DATABASE: string;
  LOAD_DATABASE_SUCCESS: string;
  LOAD_DATABASE_FAILURE: string;
  LIST_DATABASES: string;
  LIST_DATABASES_SUCCESS: string;
  LIST_DATABASES_FAILURE: string;
}

export const ActionTypes: IDatabaseActions = {
  LOAD_DATABASE: type(`${CATEGORY} Load Database`),
  LOAD_DATABASE_SUCCESS: type(`${CATEGORY} Load Database Success`),
  LOAD_DATABASE_FAILURE: type(`${CATEGORY} Load Database Failure`),
  LIST_DATABASES: type(`${CATEGORY} List Databases`),
  LIST_DATABASES_SUCCESS: type(`${CATEGORY} List Databases Success`),
  LIST_DATABASES_FAILURE: type(`${CATEGORY} List Databases Failure`),
};

export class LoadDatabaseAction implements Action {
  type = ActionTypes.LOAD_DATABASE;

  constructor(public payload: any) {
  }
}

export class LoadDatabaseSuccessAction implements Action {
  type = ActionTypes.LOAD_DATABASE_SUCCESS;

  constructor(public payload: string) {
  }
}

export class LoadDatabaseFailureAction implements Action {
  type = ActionTypes.LOAD_DATABASE_FAILURE;
  payload: string = null;
}

export class ListDatabasesAction implements Action {
  type = ActionTypes.LIST_DATABASES;

  constructor(public payload: any) {
  }
}

export class ListDatabasesSuccessAction implements Action {
  type = ActionTypes.LIST_DATABASES_SUCCESS;

  constructor(public payload: any) {
  }
}

export class ListDatabasesFailureAction implements Action {
  type = ActionTypes.LIST_DATABASES_FAILURE;
  payload: string = null;
}


export type Actions
  = LoadDatabaseAction
  | LoadDatabaseSuccessAction
  | LoadDatabaseFailureAction
  | ListDatabasesAction
  | ListDatabasesSuccessAction
  | ListDatabasesFailureAction;
